export const LOAD_PAYMENT_HISTORY = "LOAD_PAYMENT_HISTORY";
export const DISPLAY_PAYMENT_HISTORY = "DISPLAY_PAYMENT_HISTORY";
export const CLEAR_PAYMENTS_HISTORY = "CLEAR_PAYMENTS_HISTORY";
